var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm._f("std-date-time")(_vm.selectModel(_vm.modelValue, _vm.dataSelectorKey)))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }